import throttle from 'lodash.throttle';
import Tippys from './Tooltip';
import { getScrollbarWidth, libNodes, isMobileSystem } from '../utils/Utils';

const scrollbarWidth = getScrollbarWidth();

const init = () => {
    libNodes.$html.css({
        '--scrollbar_width': `${scrollbarWidth}px`,
        '--header_bottom_height': `${document.querySelector('.header__bottom').offsetHeight}px`,
        '--header_top_height': `${document.querySelector('.header__top').offsetHeight}px`
    });

    document.documentElement.addEventListener('modalopened', function() {
        this.classList.add('modal_opened');
    });

    document.documentElement.addEventListener('modalclosed', function() {
        this.classList.remove('modal_opened');
    });

    if (isMobileSystem()) {
        libNodes.$html.addClass('is_mobile');
    }

    window.addEventListener(
        'resize',
        throttle(() => {
            libNodes.$html.css({
                '--scrollbar_width': `${getScrollbarWidth()}px`,
                '--header_bottom_height': `${document.querySelector('.header__bottom').offsetHeight}px`,
                '--header_top_height': `${document.querySelector('.header__top').offsetHeight}px`
            });

            if (window.innerWidth > 991) {
                document.querySelector('.header__desktop').style = '';

                Tippys.forEach((item) => {
                    item.enable();
                });
            } else {
                document.querySelectorAll('.js_sticky_btn').forEach((item) => {
                    item.style = '';
                });

                Tippys.forEach((item) => {
                    item.disable();
                });
            }
        }, 200)
    );
};

export default init();
